import useHasRolePermissions from '../useHasRolePermissions'
import { roles } from '../../configs/permissionsConfig'

const { admin, coordinator } = roles

const OfficeHour = () => {
  const hasRolePermissions = useHasRolePermissions()

  const canChangeOfficeHour = hasRolePermissions([admin, coordinator])

  return {
    canChangeOfficeHour
  }
}

export default OfficeHour
